import { TAGS } from "../constants";
import { Employee } from "../types";
import { api } from "./api";

export const employeesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllEmployees: builder.query<
      { data: Employee[]; count: number },
      | {
          from?: number;
          to?: number;
          role?: string;
          first_name?: string;
          last_name?: string;
        }
      | undefined
    >({
      query: (params) => ({
        url: "/api/employees",
        method: "GET",
        params,
      }),
      providesTags: [TAGS.EMPLOYEES],
    }),
  }),
});

export const { useGetAllEmployeesQuery } = employeesApi;
